module.exports = __webpack_public_path__ + "static/WSC_Group_2018_Rental_Property_Tax_Check_List-6ca174e0227499ce91f165bb0bf31368.pdf";